// Sample data (specs 32).
const sampleEn = {
  "sample.order_banner": "This is a sample order. Fulfilling, refunding or cancelling it never notifies anyone and it doesn't count as a sale.",
  "sample.badge": "Sample",
  "sample.banner_title": "You're looking at sample data",
  "sample.banner_body": "{products} products, {orders} orders and {customers} customers show you how your store will work. They never send emails, reach apps or count as sales. Remove them whenever you're ready.",
  "sample.seeding": "Adding sample products, customers and orders to your store… This takes about a minute.",
  "sample.removing": "Removing sample data…",
  "sample.failed": "Sample data couldn't be added. Nothing was left behind; try again from Home.",
  "sample.remove_failed": "Removing the sample data didn't finish. Try again.",
  "sample.remove": "Remove sample data",
  "sample.remove_title": "Remove sample data?",
  "sample.remove_body": "Sample products, collections, customers, orders, discounts, pages and blog posts are deleted, and menu links to them removed. Your own products and settings stay.",
  "sample.keep_edited": "Keep the items you edited",
  "sample.kind.product": "products",
  "sample.kind.collection": "collections",
  "sample.kind.page": "pages",
  "sample.kind.article": "blog posts",
  "sample.kind.discount": "discounts",
  "sample.kind.blog": "blogs",
  "sample.show_in_reports": "Show sample data in reports",
  "sample.show_in_reports_hint": "Off: analytics and reports count only your real orders.",
  "sample.reports_on": "Reports now include sample orders.",
  "sample.reports_off": "Reports now leave sample orders out.",
  "sample.hidden_in_reports": "Sample orders are left out of these reports.",
  "sample.shown_in_reports": "These reports include sample orders.",
  "sample.explore_title": "Explore with sample data",
  "sample.explore_body": "See a working store right away: products with photos and variants, collections, customers, two months of orders, discounts, pages and a blog.",
  "sample.explore_note": "Sample data never emails anyone and comes out in one click.",
  "sample.add": "Add sample data",
  "sample.industry": "What will you sell?",
  "sample.industry.fashion": "Fashion",
  "sample.industry.electronics": "Electronics",
  "sample.industry.grocery": "Grocery & food",
  "sample.industry.beauty": "Beauty & fragrance",
  "sample.wizard_title": "Start with sample products",
  "sample.wizard_hint": "Fill your store with products, customers and orders to explore. Remove them in one click when you add your own.",
  "home.guide.remove_sample_data": "Remove sample data",
};

export default sampleEn;
